
import React, { useContext, useEffect, useState } from 'react';
import ConnUrls from '../../Connections/ConnectURL';
import { MasterContext } from '../../ContextApi/context';
import BigPopUpMsg from '../BigPopUpMsg';
import PopUpMsg from '../PopUpMsg';
import TopBigSlides from '../TopBigSlides';
import PopUpClearComp from '../PopUpClearComp';
import PopUpHappy from '../PopUpHappy';
import PopUpsSlides from '../PopUpsSlides';


const Out_Of_Hours = (props) => {

    const [master] = useContext(MasterContext);

    return (
        // <PopUpMsg
        //     Title={["סגור כעת!"]}
        //     nosnippet={true}
        //     cssStyl={"okPOP"}
        //     topSlides={<TopBigSlides TopImages={[{ img: master.nowCloseImg, txt: "" }]} />}
        //     ContentText={[{ txt: "עסק זה כרגע סגור", css: "" },
        //     { txt: "ולא ניתן לבצע הזמנות", css: "" }]}
        //     inLabel={""}
        //     BtnTxt={"ביטול"}
        //     okClick={() => props.okClick()}
        //     BtnTxt2={"עבור לעמוד המסעדה"}
        //     btn1Css={"btnRed bold btnPoppadding15"}
        //     btn2Css={"btnGreen bold btnPoppadding15"}
        //     btnClick2={() => { props.btn2Click() }}
        //     errorMsg={""} />




        <PopUpClearComp
            popFullComp={"specialPopComp onTopOfAll"}
            cssStyl={"noPadding"}
            btnFStyle={"fatInBtn"}
            // closePop={() => setThePopUp()}
            insideCss={"noPadding"}
            theInsideComp={
                <PopUpHappy
                    Title={["עסק זה סגור כרגע"]}
                    cssStyl={"okPOP onTopOfAll"}
                    topSlides={<PopUpsSlides key={"logInPop"}
                        TopImages={[{ img: master.nowCloseImg, txt: "" }]} />}
                    ContentText={[{ txt: "עסק זה כרגע סגור", css: "" }
                        , { txt: "ולא ניתן לבצע הזמנות", css: "" }]}
                    inLabel={""}
                    okClick1={() => props.okClick()}
                    okClick2={() => props.btn2Click()}
                    okTxt1={"סגור"}
                    okTxt2={"עבור לעמוד המסעדה"}
                />

            } />
    )
}


export default Out_Of_Hours;